import { render, staticRenderFns } from "./AnimationSelect.vue?vue&type=template&id=b8b3c376&"
import script from "./AnimationSelect.vue?vue&type=script&lang=js&"
export * from "./AnimationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports